import {Title} from 'src/design/atoms/Title';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

interface FormStaticV2Props {
  field: IFormFieldV2;
}

export const FormHeadingV2 = React.memo<FormStaticV2Props>(
  ({field}: FormStaticV2Props) => {
    return <Title order={4}>{field.label}</Title>;
  }
);
